import type { ChangeEvent, ReactNode, SelectHTMLAttributes } from 'react'

type Base = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value' | 'children'>

export function Select({
  value,
  onChange,
  onChangeEvent,
  children,
  className,
  ...rest
}: {
  readonly value: string
  readonly onChange?: (value: string) => void
  readonly onChangeEvent?: (event: ChangeEvent<HTMLSelectElement>) => void
  readonly children: ReactNode
} & Base) {
  return (
    <select
      className={['ui-control', className ?? ''].filter((c) => c !== '').join(' ')}
      value={value}
      onChange={(event) => {
        onChange?.(event.target.value)
        onChangeEvent?.(event)
      }}
      {...rest}
    >
      {children}
    </select>
  )
}
